// extracted by mini-css-extract-plugin
export default {"container":"player-clip-details_container__2QEqm","video-wrapper":"player-clip-details_video-wrapper__vPeUc","info":"player-clip-details_info__yCPEL"};